import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row, Container, Table } from 'react-bootstrap';

import SelectDropDown from '../selectdropdown/SelectDropDown';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";
import ExcelContainerForAttendance from './ExcelContainerForAttendance.jsx';



class AttendanceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        console.log("llllllllllllllllll",this.props.stateData.loader)

       
            return (
                <Modal {...this.props}
                    size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Section Wise Data</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <Container className='table_data'>
                            <Row>
                                <Col>
                                    <ExcelContainerForAttendance stateData={this.props.stateData} />
                                </Col>
                            </Row>
                            <Row className='align_center'>
                                <Col xl={12} lg={12} md={12} >
                                    {
                                        this.props.stateData.loader == 1 ?
                                        (
                                            <Container>
                                                <Row>
                                                    <Col sm={12}>
                                                        <div className="spinner-border text-primary text-center loading-img-center"></div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        )
                                        :
                                        (
                                            <table width="100%" style={{ height: "500px" }}>
                                            <thead>
                                                <tr>
                                                    <th rowSpan="2">Student Name</th>
                                                    <th rowSpan="2">Roll no</th>
                                                    <th colSpan={this.props.stateData.dateArrayfinal.length}>Dates</th>
                                                </tr>
    
                                                <tr>
                                                    {
                                                        this.props.stateData.dateArrayfinal.map((item => {
                                                            return (<th>{item}</th>)
                                                        }))
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.props.stateData.getStudenWiseAttendanceData.length > 0 ?
                                                        (
                                                            this.props.stateData.getStudenWiseAttendanceData.map((item) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{item.student_name}</td>
                                                                            <td>{item.roll_no}</td>
                                                                            {
                                                                                item.dayWiseData.map((item2) => {
                                                                                    return (
                                                                                        <td className={item2.attendance_status == "P" ? "present" : item2.attendance_status == "A" ? "absent" : "blank"}>{item2.attendance_status}</td>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                        )
                                                        :
                                                        (
                                                            ""
    
                                                        )
                                                }
                                            </tbody>
                                        </table>
                                        )
                                    }
                                   

                                </Col>
                            </Row>
                        </Container>


                    </Modal.Body>
                    <Modal.Footer variant="white" className="px-4">

                    </Modal.Footer>
                </Modal >
            )
    }
}

export default (AttendanceModal);